<template>
  <cd-layout>
    <template #page-title>
      Payment Processing
    </template>

    <template #page-meta>
      Please wait, Payment under Process
    </template>

    <template #page-body>
      <div class="process">
        <div class="process-spinner">
          <img src="../assets/images/svg/icon-processing.svg" alt="" />
        </div>
      </div>
    </template>
  </cd-layout>
</template>
<script>
import CdLayout from '../layouts/CdLayout'

export default {
  name: 'Process',
  components: {
    CdLayout
  },
  data () {
    return {}
  },
  methods: {},
  computed: {}
}
</script>
<style lang="scss"></style>



// WEBPACK FOOTER //
// src/views/Process.vue